import { Input } from "@/components/ui/input";
import { Youtube, CheckCircle2, XCircle } from "lucide-react";
import { isValidYoutubeUrl } from "@/utils/youtube";

interface YouTubeUrlInputProps {
  url: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const YouTubeUrlInput = ({ url, onChange, disabled }: YouTubeUrlInputProps) => {
  return (
    <div className="relative flex-1">
      <Input
        type="url"
        placeholder="Paste YouTube URL here"
        value={url}
        onChange={(e) => onChange(e.target.value)}
        className="pr-10 bg-muted/50 transition-all duration-300 focus:ring-2 focus:ring-primary h-12"
        disabled={disabled}
      />
      <div className="absolute right-3 top-1/2 -translate-y-1/2">
        {url ? (
          isValidYoutubeUrl(url) ? (
            <CheckCircle2 className="h-5 w-5 text-green-500" />
          ) : (
            <XCircle className="h-5 w-5 text-red-500" />
          )
        ) : (
          <Youtube className="h-5 w-5 text-muted-foreground" />
        )}
      </div>
    </div>
  );
};